// Store
import store from "@/store/index";

export interface AppCoachDiagnosticsRootListFormCreate {
  user_id: string;
  organization_id: string;
  diagnostic_category_id: string;
  content: {
    date: string;
    fields: any;
  };
}

export class AppCoachDiagnosticsRootListFormCreate implements AppCoachDiagnosticsRootListFormCreate {
  user_id: string;
  organization_id: string;
  diagnostic_category_id: string;
  content: {
    date: string;
    fields: any;
  };

  constructor() {
    this.user_id = "";
    this.organization_id = store.getters.getOrganizationMember.organization_id ?? "";
    this.diagnostic_category_id = "";
    this.content = {
      date: "",
      fields: [],
    };
  }
}